import React from 'react'

export const Cid = () => {
  return (
    <div>Cid</div>
  )
}

